<template>
  <div class="about-join com-padding-top-70 com-padding-bottom-90">
    <div class="com-content-1560">
      <div class="dn-upper text-align-center">
        <div class="com-title1">I want to represent</div>
        <div class="com-title2">Grasp the new decade of continuous growth of stock market</div>
      </div>
      <div class="dn-form com-padding-top-50">
        <el-form
            :model="ruleForm" ref="ruleForm" label-position="top" class="el-form1">
          <el-form-item label="* Full name：" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="* Contact information：" prop="phone">
            <el-input v-model="ruleForm.phone"></el-input>
          </el-form-item>
          <el-form-item label="Agency channel：" prop="channel">
            <el-input v-model="ruleForm.channel"></el-input>
          </el-form-item>
          <el-form-item label="Agent category：" prop="agent_id">
            <el-select filterable clearable v-model="ruleForm.agent_id" style="width: 100%;">
              <el-option
                  v-for="item in dataSelect" :key="item.id"
                  :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="* Area：" prop="city_attr" class="el-form-item-middle">
            <el-cascader
                style="width: 100%;"
                :options="optionsCascader" v-model="city_attr"
                :props="{ expandTrigger: 'hover' }" @change="changeCascader">
            </el-cascader>
          </el-form-item>
          <el-form-item label="* Is there an agent nearby：" prop="is_nearby_agents">
            <el-radio-group v-model="ruleForm.is_nearby_agents">
              <el-radio :label="0">No</el-radio>
              <el-radio :label="1">Yes</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="* Have you ever been an agent of other brands：" prop="is_agents" class="el-form-item-middle">
            <el-radio-group v-model="ruleForm.is_agents">
              <el-radio :label="0">No</el-radio>
              <el-radio :label="1">Yes</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="Do you have anything else to add：" prop="note" class="el-form-item-large">
            <el-input type="textarea" v-model="ruleForm.note" :rows="5"></el-input>
          </el-form-item>
          <!--
          <el-form-item label="* 验 证 码：" prop="captcha">
            <el-input v-model="ruleForm.captcha"></el-input>
            <img src="http://huanguan.zyrkeji.cn/index.php/api/v1/basis/findCaptcha" alt="">
          </el-form-item>
          -->
          <el-form-item class="el-form-item-large">
            <el-button @click="submitForm('ruleForm')" class="el-button1">Submit</el-button>
          </el-form-item>
        </el-form>
      </div>

    </div>
  </div>
</template>

<script>
import {regionData, CodeToText} from 'element-china-area-data'

export default {
  data() {
    return {
      optionsCascader: regionData,
      city_attr: [],

      dataSelect: [],
      modelRadioagent: 0,
      modelRadioother: 0,
      imgcode: '',
      ruleForm: {
        name: '',
        phone: '',
        channel: '',
        agent_id: '',
        city_attr: '',
        is_nearby_agents: '',
        is_agents: '',
        note: '',
        // captcha: '',
      },
      rules: {
        name: [{required: true, message: 'Please enter your name', trigger: 'blur'}],
        phone: [{required: true, message: 'Please enter the contact information', trigger: 'blur'}],
        region: [{required: true, message: 'Please select your region', trigger: 'change'}],
        // code: [{required: true, message: '请输入验证码', trigger: 'blur'}],
      }
    }
  },
  created() {
    // this.dataRequestbasis_findCaptcha()
    this.dataRequestcontactus_getAgent()
  },
  methods: {
    // 选择省市区
    changeCascader(value) {
      this.ruleForm.city_attr = CodeToText[value[0]] + ',' + CodeToText[value[1]] + ',' + CodeToText[value[2]]
      console.log(this.ruleForm.city_attr)
    },
    // 招商加盟-获取代理品类
    dataRequestcontactus_getAgent() {
      this.$api.user.contactus_getAgent().then(res => {
        this.dataSelect = res.data.list
      })
    },
    /**
     // 获取图形验证码
     dataRequestbasis_findCaptcha() {
      this.$api.user.basis_findCaptcha().then(res => {
        console.log('res:', res)
        this.imgcode = res
      })
    },
     **/
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.dataRequestcontactus_submitAgent()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
// 招募加商-提交代理信息
    dataRequestcontactus_submitAgent() {
      let params = {
        ...this.ruleForm,
      }
      this.$api.user.contactus_submitAgent(params).then(res => {
        console.log(res)
        if (res.code != 200) {
          this.$notify({
            message: res.message,
            type: 'error',
            duration: 2000
          })
        } else {
          this.$notify({
            message: '提交成功',
            type: 'success',
            duration: 2000
          })
          this.$refs.ruleForm.resetFields()
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
.about-join {
  .dn-form {
    .el-form1 {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .el-form-item {
        width: calc(100% / 3 - 2%);

        &.el-form-item-middle {
          width: calc(100% / 3 * 2 - 1%);
        }

        &.el-form-item-large {
          width: calc(100% / 1);
        }
      }

      ::v-deep.el-form-item__label {
        padding: 0;
      }

      .el-button1 {
        background: $color2;
        color: #ffffff;
        padding: 15px 200px;
        font-size: 22px;
        margin: auto;
        display: block;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .about-join {
    .dn-form {
      .el-form1 {
        .el-form-item {
          width: calc(100% / 1) !important;
          margin-bottom: 10*$mobile-conversion;
        }

        .el-button1 {
          padding: 20*$mobile-conversion 200*$mobile-conversion;
          font-size: 30*$mobile-conversion;
        }
      }
    }
  }
}
</style>
